import { useCallback, useState } from 'react';

import { useBrowserEventListener } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

// ─────────────────────────────────────────────────────────────────────────────

export const useMenuLineageKeyCopyMode = () => {
  const isFeatureEnabled = useFeatureFlag('CELS-5655-order-menu-lineage-key-copy-enabled');

  // ─── State ───────────────────────────────────────────────────────────

  const [isShortcutPressed, setIsShortcutPressed] = useState(false);

  // ─── Handlers ────────────────────────────────────────────────────────

  const handleShortcutChange = useCallback((event: KeyboardEvent) => {
    setIsShortcutPressed(checkIfLineageKeyCopyShortcutPressed(event));
  }, []);

  const handleWindowBlur = useCallback(() => {
    setIsShortcutPressed(false);
  }, []);

  // ─── Effects ─────────────────────────────────────────────────────────

  const browserWindow = isFeatureEnabled ? window : null;

  useBrowserEventListener(browserWindow, 'keydown', handleShortcutChange);
  useBrowserEventListener(browserWindow, 'keyup', handleShortcutChange);
  useBrowserEventListener(browserWindow, 'blur', handleWindowBlur);

  return isFeatureEnabled && isShortcutPressed;
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function checkIfLineageKeyCopyShortcutPressed(event: KeyboardEvent) {
  return event.metaKey && event.shiftKey;
}
